const DEFAULT_APP_URL = 'https://app.beclients.ru';

function trimTrailingSlash(url: string): string {
  return url.replace(/\/$/, '');
}

export function resolveMasterAppUrl(): string {
  const fromEnv = import.meta.env.VITE_APP_URL?.trim();
  return trimTrailingSlash(fromEnv ?? DEFAULT_APP_URL);
}

export function resolveVkAppId(): string | null {
  const fromEnv = import.meta.env.VITE_VK_APP_ID?.trim();
  return fromEnv || null;
}

export function buildTelegramReferralRedirect(refCode: string): string {
  const url = new URL(resolveMasterAppUrl());
  url.searchParams.set('ref', refCode);
  return url.toString();
}

export function buildVkReferralRedirect(refCode: string): string | null {
  const appId = resolveVkAppId();
  if (!appId) return null;
  const url = new URL(`https://vk.com/app${appId}`);
  url.searchParams.set('ref', refCode);
  return url.toString();
}
